/**
 * @file IconPicker.tsx
 * @description Значок кнопки, шапки раздела или объявлений (phase19.16 Р2;
 * uiux-design-r2 §4): [Нет][Стрелка][Telegram][VK][Телефон][Корзина][Письмо]
 * сеткой по 48. Набор — `SITE_ICON_KEYS` shared, подписи и значки —
 * реестр `SITE_ICON_META`.
 */

import { SITE_ICON_KEYS, type SiteIconKey } from "@chaiberi/shared";
import { Ban } from "lucide-react";

import { Label } from "../../../ui/label";
import { SITE_ICON_META } from "../../../../lib/site-builder/section-meta";
import { cn } from "@/lib/utils";

interface Props {
  label?: string;
  value: SiteIconKey | null | undefined;
  /** `null` — без значка. */
  onChange: (icon: SiteIconKey | null) => void;
}

export function IconPicker({ label = "Значок", value, onChange }: Props) {
  const options: Array<{ key: SiteIconKey | null; label: string; Icon: typeof Ban }> = [
    { key: null, label: "Нет", Icon: Ban },
    ...SITE_ICON_KEYS.map((key) => ({ key, label: SITE_ICON_META[key].label, Icon: SITE_ICON_META[key].icon })),
  ];
  return (
    <div className="flex flex-col gap-1">
      <Label>{label}</Label>
      <div role="radiogroup" aria-label={label} className="flex flex-wrap gap-1">
        {options.map(({ key, label: name, Icon }) => {
          const active = (value ?? null) === key;
          return (
            <button
              key={key ?? "none"}
              type="button"
              role="radio"
              aria-checked={active}
              onClick={() => onChange(key)}
              className={cn(
                "inline-flex min-h-12 items-center gap-1.5 rounded-lg px-3 text-sm outline-none focus-visible:ring-2 focus-visible:ring-ring",
                active ? "bg-primary/10 font-medium text-on-surface [box-shadow:inset_0_0_0_1px_var(--primary)]" : "bg-surface-low text-on-surface-variant hover:text-on-surface",
              )}
            >
              <Icon aria-hidden className="size-4" />
              {name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
